/**
 * Employee Incident Approval Service
 * HTTP operations for the individual approval of a marking incident
 * (ASIS-5247 / REXASIS-005)
 */
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_ApproveIncidentIn, LC_ApproveIncidentOut } from '../types';

/**
 * Service for approving an individual marking incident.
 */
export class EmployeeIncidentApproveService {
  /**
   * Approve a marking incident (ASIS-5247). Only the approver comment is
   * sent; the incident id comes from the route and the approver identity is
   * resolved on the backend (JWT). Always returns HTTP 200 with an `outcome`
   * discriminator: 'approved' (success) or 'alreadyResolved' (concurrency,
   * carries the real currentState).
   * PUT /v1/attendances/incidents/{incidentId}/approval
   */
  approve(
    incidentId: number,
    input: LC_ApproveIncidentIn,
  ): Promise<ApiResponse<LC_ApproveIncidentOut>> {
    return apiClient.put<LC_ApproveIncidentOut>(
      API_CONFIG.ENDPOINTS.EMPLOYEE_INCIDENTS.APPROVE_MANAGEMENT(incidentId),
      input,
    );
  }
}

export const employeeIncidentApproveService = new EmployeeIncidentApproveService();
